import React from "react"
import {
	Grid,
	Typography,
	Chip,
	CircularProgress,
	Card
} from "@material-ui/core"
import {
	FormatQuoteOutlined as FormatQuoteIcon
} from "@material-ui/icons"

import { themeColors } from "letalkui"

import { MeetingAnalysis } from "@/services/MeetingAnalyzerService"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/ObjectionAndConversionCards/styles"
import {
	getScoreLabel,
	objectionToDisplayText,
	scoreLabelToColor,
	scoreLabelToDisplayText
} from "@/utils/meetingAnalyzer"

type ObjectionAndConversionCardsProps = {
	analysis: MeetingAnalysis
}

const ObjectionAndConversionCards: React.FC<ObjectionAndConversionCardsProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	if (!analysis.output) {
		return null
	}

	const conversionValue = analysis.output.conversionProbability
	const conversionLabel = getScoreLabel(conversionValue)
	const conversionColor = scoreLabelToColor[conversionLabel]

	return (
		<Grid container spacing={3}>
			<Grid item xs={6}>
				<Card className={meetingAnalyzerClasses.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Grid container justifyContent="space-between" alignItems="center">
								<Grid item>
									<Typography className={meetingAnalyzerClasses.cardTitle}>
										Principal objeção
									</Typography>
								</Grid>
								<Grid item>
									<Chip
										className={classes.objectionCategoryChip}
										label={objectionToDisplayText[analysis.output.mainObjection.category]}
										size="small"
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Typography className={meetingAnalyzerClasses.cardSubtitle}>
								Categoria identificada pela IA com base na transcrição.
							</Typography>
						</Grid>
						<Grid item>
							<Typography className={classes.objectionSummary}>
								{analysis.output.mainObjection.text}
							</Typography>
						</Grid>
						<Grid item>
							<Typography className={meetingAnalyzerClasses.quoteBox}>
								<FormatQuoteIcon fontSize="small" className={meetingAnalyzerClasses.quoteIcon} />
								{analysis.output.mainObjection.excerpt}
							</Typography>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={6}>
				<Card className={meetingAnalyzerClasses.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Typography className={meetingAnalyzerClasses.cardTitle}>
								Probabilidade de conversão
							</Typography>
						</Grid>
						<Grid item>
							<Typography className={classes.conversionSubtitle}>
								Calculada com base no score geral e nos sinais comportamentais identificados.
							</Typography>
						</Grid>
						<Grid item>
							<Grid container alignItems="center" justifyContent="center" style={{ position: "relative" }}>
								<CircularProgress
									variant="static"
									value={100}
									size={120}
									thickness={5}
									style={{ color: themeColors.colors.system.gray[200], position: "absolute" }}
								/>
								<CircularProgress
									variant="static"
									value={conversionValue}
									size={120}
									thickness={5}
									style={{ color: conversionColor.dotColor }}
								/>
								<Grid item style={{ position: "absolute" }}>
									<Grid container direction="column" alignItems="center">
										<Grid item>
											<Typography className={meetingAnalyzerClasses.scoreGeneralNumber} style={{ fontSize: "1.75rem", color: conversionColor.textColor }}>
												{conversionValue}%
											</Typography>
										</Grid>
										<Grid item>
											<Typography className={classes.conversionLabel} style={{ color: conversionColor.textColor }}>
												{scoreLabelToDisplayText[conversionLabel].toUpperCase()}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
		</Grid>
	)
}

export default ObjectionAndConversionCards
